import { render, staticRenderFns } from "./CameraCreate.vue?vue&type=template&id=1b63eed0&"
import script from "./CameraCreate.vue?vue&type=script&lang=js&"
export * from "./CameraCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports